import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  ledgerProviderCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";

/**
 * Désactive un provider (`DELETE /Providers/{id}`) — réservé à
 * flashpay-superadmin. Seul le code HTTP fait foi (pas de corps typé).
 */
export const useDeleteProvider = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "providers", "delete"],
    mutationFn: (providerId: string) =>
      mutateData({
        url: ledgerEndpoints.providers.delete(providerId),
        method: "DELETE",
      }),
    onSuccess: (_data, providerId) => {
      return invalidateAfterMutation(
        queryClient,
        ledgerProviderCacheKeys(providerId)
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteProvider failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
